var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialIginline = function SvgSocialIginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2110_34049)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0ZM9.032 4.843c.769-.034 1.015-.043 2.97-.043 1.955 0 2.201.009 2.973.04.77.034 1.292.157 1.75.334.471.186.874.432 1.275.832.4.4.648.8.831 1.275.178.46.3.984.335 1.75.034.769.043 1.012.043 2.97 0 1.958-.009 2.201-.043 2.97-.034.77-.157 1.292-.335 1.75A3.574 3.574 0 0 1 18 17.996c-.4.4-.8.649-1.275.831-.46.178-.984.3-1.75.335-.769.034-1.012.043-2.97.043-1.958 0-2.201-.009-2.97-.043-.77-.034-1.292-.157-1.75-.335a3.572 3.572 0 0 1-1.275-.831c-.4-.4-.649-.8-.831-1.275-.178-.46-.3-.984-.335-1.75-.034-.769-.043-1.015-.043-2.97 0-1.955.009-2.201.043-2.967.034-.77.157-1.292.335-1.75.185-.472.431-.875.831-1.275.4-.4.8-.649 1.275-.832.458-.177.98-.3 1.747-.334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.002 8.305a3.7 3.7 0 1 0 .001 7.399 3.7 3.7 0 0 0-.001-7.4Zm0 6.097a2.4 2.4 0 1 1 0-4.802 2.4 2.4 0 0 1 0 4.802ZM15.847 9.02a.863.863 0 1 0 0-1.727.863.863 0 0 0 0 1.726Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2110_34049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
};
export default SvgSocialIginline;